import { FC } from 'react'
import {
  Text,
  Banner,
  IndigoIndigo60,
  Primary13Regular,
  Flex,
  Link
} from '@sequencehq/core-components'
import { Dashboardv99990101Api } from '@sequencehq/api/dashboard/v99990101'
import {
  startNodeTriggerLabel,
  StartNodeTrigger
} from 'Automations/nodeDefinitions/definitions/start'
import { automationsPaths } from 'Automations/router'

type TriggerType = Dashboardv99990101Api.Automations.TriggerType

type Props = {
  conflictingAutomationId: string
  conflictingAutomationName: string
  triggerType: TriggerType
}

export const DuplicateTriggerWarningBanner: FC<Props> = ({
  conflictingAutomationId,
  conflictingAutomationName,
  triggerType
}) => {
  const triggerLabel =
    triggerType in startNodeTriggerLabel
      ? startNodeTriggerLabel[triggerType as StartNodeTrigger]
      : triggerType

  return (
    <Banner variant="warning" data-testid="automations.duplicateTriggerWarning">
      <Flex flexDir="column" gap="8px">
        <Text as="p" color="inherit" fontSize="inherit" lineHeight="inherit">
          The published workflow{' '}
          <Link
            to={automationsPaths.automationsEditor({
              automationId: conflictingAutomationId
            })}
            isExternal
            _hover={{ textDecoration: 'none' }}
            data-testid="automations.duplicateTriggerWarning.conflictingWorkflowLink"
          >
            <Text {...Primary13Regular} as="span" color={IndigoIndigo60}>
              {conflictingAutomationName}
            </Text>
          </Link>{' '}
          already uses the{' '}
          <Text
            as="span"
            fontWeight={600}
            color="inherit"
            fontSize="inherit"
            lineHeight="inherit"
          >
            {triggerLabel}
          </Text>{' '}
          type. Only one published workflow per type is&nbsp;allowed.
        </Text>

        <Text as="p" color="inherit" fontSize="inherit" lineHeight="inherit">
          Publishing this workflow will unpublish the currently
          published&nbsp;workflow.
        </Text>
      </Flex>
    </Banner>
  )
}
